<template>
    <div>
        <el-input ref="editInput" v-model.trim="checkName" @input.native="ex" size="mini" clearable @blur="reBack"></el-input>
    </div>
</template>

<script>
export default {
    name: 'FinEditInput',
    props: {
        name: {
            type: String
        },
        id: {
            type: Number
        }
    },
    data() {
        return {
            checkName: '',
            check_id: null,
            timer_edit_body: null,
        }
    },
    watch: {
        name(n) {
            this.checkName = ''
            if (n) {
                this.checkName = n
            }
        },
        id(n) {
            this.check_id = null
            this.flag = false
            if (n) {
                this.check_id = n
                this.flag = true
            }
        },
    },
    methods: {
        ex () {
            this.doEditPrice()
        },
        doEditPrice() {
            if (this.timer_edit_body) {
                clearTimeout(this.timer_edit_body)
            }
            this.timer_edit_body = setTimeout(() => {
                this.$nextTick(() => {
                    this.execEditPrice()
                })
            }, 400)
        },
        execEditPrice() {
            if (!this.check_id) return false
            this.$axios.post('api/admin/process/check/edit_store', {
                check_setting: {
                    id: this.check_id,
                    check_name: this.checkName
                }
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.$message.success(data.msg)
                    this.$emit('updatePrice')
                } else {
                    this.$message.error(data.msg)
                }
            }).catch()
        },
        reBack() {
            this.$emit('revert')
        }
    },
    mounted() {
        this.$refs.editInput.focus()
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/setting_panel/components/EditInput.vue